import { SET_DEFAULT_LANGUAGE, RESET_DEFAULT_LANGUAGE } from "../types";

const initialState = {
    language: 'it', 
};

const defaultLanguageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DEFAULT_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            }
        case RESET_DEFAULT_LANGUAGE:
            return {
                ...state,
                language: null, 
            }
        default:
            return state;
    }
};

export default defaultLanguageReducer;